export const TrainingFieldLabels = {
  name: 'Name',
  description: 'Description',
  groups: 'Training Groups',
  sections: 'Training Sections',
  frequency: 'Recurring Schedule',
  taskFiles: 'Document References',
  changeOrders: 'Change Orders',
  attachment: 'Attachments'
} as const;

export type TrainingField = keyof typeof TrainingFieldLabels;

export const TrainingFields: TrainingField[] = Object.keys(
  TrainingFieldLabels
) as TrainingField[];
